import { render, staticRenderFns } from "./CostsDonate.vue?vue&type=template&id=deb7f9c6&scoped=true&"
import script from "./CostsDonate.vue?vue&type=script&lang=js&"
export * from "./CostsDonate.vue?vue&type=script&lang=js&"
import style0 from "./CostsDonate.vue?vue&type=style&index=0&id=deb7f9c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb7f9c6",
  null
  
)

export default component.exports